var map = {
	"./bol-niet-waar.svg": 9206,
	"./bol-waar.svg": 4231,
	"./icon-circel-niet-waar.png": 5549,
	"./icon-circel-waar-2.png": 3191,
	"./icon-circel-waar-3.png": 784,
	"./icon-circel-waar.png": 4060,
	"./ja-2.png": 2385,
	"./ja.png": 5249,
	"./nee-2.png": 2310,
	"./nee.png": 1655,
	"./niet-te-zeggen-2.png": 1417,
	"./niet-te-zeggen.png": 5253,
	"./slider-thumb.png": 5761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;